import { __ } from '@wordpress/i18n';
import {PanelBody,RangeControl} from '@wordpress/components';
import { VayuBlocksDevice,VayuBlocksDeviceControl } from '@vayu-blocks/device-control';
import {VayuBlocksToggleControl, VayuBlocksRangeControl, VayuBlocksBackground, VayuBlocksBorder, VayuBlocksColorControl } from '@vayu-blocks';
import { useState } from '@wordpress/element';
import { SlideButton } from '@vayu-blocks/global';

const Style = ({ attributes, setAttributes, openPanels, onTogglePanel }) => {

    const getView = VayuBlocksDevice();

    const [hover, sethover] = useState('normal');

    const handelHover = (value) => {
        sethover(value);
        if (typeof clickBorderHover === 'function') {
            clickBorderHover(value);
        }
    }

    const vayu_blocks_thickness = () => {
        switch (getView) {
            case 'Desktop':
                return attributes.thickness;
            case 'Tablet':
                return attributes.thicknessTablet;
            case 'Mobile':
                return attributes.thicknessMobile;
            default:
                return undefined;
        }
    }

    const vayu_blocks_thickness_block = (value) => {
        switch (getView) {
            case 'Desktop':
                setAttributes({ thickness: value });
                break; // Prevents fallthrough
            case 'Tablet':
                setAttributes({ thicknessTablet: value });
                break;
            case 'Mobile':
                setAttributes({ thicknessMobile: value });
                break;
            default:
                // Handle unexpected cases if needed
                break;
        }
    };

    return (

        <>

            <PanelBody title={__('Timeline Child', 'vayu-blocks')} opened={openPanels['slide-child']} onToggle={() => onTogglePanel('slide-child')}>

                <VayuBlocksRangeControl	
					label={<VayuBlocksDeviceControl label={__('Gap between child', 'vayu-blocks')} classname='bold' />}
					min={0}
					max={30}
					marks
					step={3}
					withInputField={false}
					onChange={(key, value) => setAttributes({ [key]: value })}
                    attribute={{key:'gapchild', value:attributes.gapchild}}
				/>

                <SlideButton  
                    button={{ normal: "Normal", hover: "Hover" }}
                    onChange={(value)=>handelHover(value)}
                    defaultValue={'normal'}
                />  

                {hover === 'normal' && (
                    <VayuBlocksColorControl
                        onChange={(key, value) => setAttributes({ [key]: value })}
                        background={{ value: attributes.gbadvBackground, backgroundKey: 'gbadvBackground' }}
                    />
                )}

                {hover === 'hover' && (
                    <VayuBlocksColorControl
                        onChange={(key, value) => setAttributes({ [key]: value })}
                        background={{ value: attributes.gbadvBackgroundHover, backgroundKey: 'gbadvBackgroundHover' }}
                    />
                )}

                <VayuBlocksBorder 
					onChange={(key,value)=>setAttributes({[key]:value})}
					border={{key:'layoutborder',value:attributes.layoutborder}}
					borderRadius={{key:'layoutradius',value:attributes.layoutradius}}
                    dropShadow={{ key: 'layoutShadow', value: attributes.layoutShadow }}
				/>

            </PanelBody>
            
            <PanelBody title={__('Connector', 'vayu-blocks')} opened={openPanels['slide-connector']}  onToggle={() => onTogglePanel('slide-connector')}>

                <VayuBlocksToggleControl
                    label={ __( 'Connector', 'vayu_blocks' ) }
                    checked={ attributes.connector }
                    onChange={ ( value ) => setAttributes( { connector: value } )}
                />

                {attributes.connector && (
                    <>
                        <RangeControl
                            __next40pxDefaultSize={true}
                            __nextHasNoMarginBottom={true}
                            max={10}
                            label={<VayuBlocksDeviceControl label={__('Size', 'vayu-blocks')} />}
                            min={0}
                            value={vayu_blocks_thickness()}
                            onChange={(value)=> vayu_blocks_thickness_block(value)}
                        />

                        <VayuBlocksBackground
                            onChange={(key,value)=>setAttributes({[key]:value})}
                            colorPanel = {[
                                {
                                    active: ['color'],
                                    label: 'Background',
                                    value: attributes.connectorcolor,
                                    key: 'connectorcolor',
                                },
                            ]}
                            headingLabel="Background"
                        />  
                    </>
                )}

            </PanelBody>

        </>

    );
};

export default Style;